import React, { Component } from 'react';
import { Link } from 'react-router';

import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withOnline from '../../common/withOnline';

import Header from '../../components/Header';
import Bugsnag from '../../helpers/bugsnag';
import {
  sortData,
} from '../../common/globals';
import {
  getSurgeonNotesList
} from '../../utils/utils';
import {
  getAllSurgeonNotes,
} from '../../utils/db';

class ChooseSurgeon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      surgeonNoteData: [],
      originalSurgeonNoteData: [],
      search: ''
    };
    this.internalServerErrorModal = null;
  }

  componentDidMount() {
    try {
      this.internalServerErrorModal = new window.bootstrap.Modal(window.$('#internalServerErrorModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getSurgeonNotesData = async () => {
    try {
      const { online, setLoader, notify } = this.props;
      setLoader(true);

      if (online) {
        const surgeonNoteRes = await getSurgeonNotesList();
        const { message, status, data } = surgeonNoteRes;
        if (status) {
          const sortedObjs = sortData(data, 'SurgeonName');

          this.setState({
            surgeonNoteData: sortedObjs,
            originalSurgeonNoteData: sortedObjs
          });
        } else {
          notify({ type: 'error', message });
        }
      } else {
        this._fetchLocalSurgeonNotes();
      }

      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _fetchLocalSurgeonNotes = async () => {
    try {
      const finalSurgeonNoteList = await getAllSurgeonNotes();
      const sortedObjs = sortData(finalSurgeonNoteList, 'SurgeonName');
      this.setState({
        surgeonNoteData: sortedObjs,
        originalSurgeonNoteData: sortedObjs
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearch = (event) => {
    try {
      let searchTxt = '';
      searchTxt = event.target.value;
      this.setState({ search: searchTxt }, () => {
        this._searchSurgeonNote();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _searchSurgeonNote = () => {
    try {
      const { search, originalSurgeonNoteData } = this.state;
      if (search && search.length > 0) {
        const searchData = search.toUpperCase();
        const searchRes = originalSurgeonNoteData.filter((surgeon) => {
          // Search by SurgeonName
          const surgeonNameMatch = surgeon.SurgeonName
            && surgeon.SurgeonName.toUpperCase().includes(searchData);

          // Search in the notes array
          const notesMatch = surgeon.notes && surgeon.notes.some(
            (note) => (note.NoteTitle && note.NoteTitle.toUpperCase().includes(searchData))
              || (note.Note && note.Note.toUpperCase().includes(searchData))
          );

          // Return true if either the SurgeonName matches or any of the notes match
          return surgeonNameMatch || notesMatch;
        });

        const sortedObjs = sortData(searchRes, 'SurgeonName');
        this.setState({
          surgeonNoteData: sortedObjs
        });
      } else {
        this.setState({
          surgeonNoteData: originalSurgeonNoteData
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      await this._getSurgeonNotesData();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { surgeonNoteData, search } = this.state;
    const {
      pageTitle,
      onGoBackSurgeon,
      onSelect
    } = this.props;

    return (
      <section className="list-section">
        <Header title={pageTitle} goBack={onGoBackSurgeon} />
        <section className="sets-section">
          <div className="container resizer-class">
            <div className="top-block sticky-pref-search">
              <div className="row gx-2">
                <div className="col-12 pt-2 pb-2">
                  <input
                    type="text" className="form-control search-input x-ray-choose-file"
                    placeholder="Search for a Surgeon"
                    onChange={(e) => this._onSearch(e)}
                    value={search}
                  />
                </div>
              </div>
            </div>

            <div className="sets-list-blocks t-b-border-0 p-0">

              {
                surgeonNoteData.length > 0
                  ? surgeonNoteData.map((item, index) => (
                    <div className="sets-block" key={index + 1}>
                      <div
                        className="row gx-3 cursor-pointer bd-b-gray"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${index + 1}`}
                        style={{ borderBottom: '1px solid #666' }}
                      >
                        <div className="col">
                          <Link
                            key={index}
                            onClick={() => onSelect(item)}
                          >
                            <p className="m-2">
                              {item.SurgeonName} {typeof item.notes !== 'undefined' && item.notes.length > 0 ? `(${item.notes.length})` : ''}
                            </p>
                          </Link>
                        </div>
                      </div>
                    </div>
                  )) : <p className="text-center mt-5">No Surgeon Notes Found.</p>
              }

            </div>

          </div>
        </section>
      </section>
    );
  }
}

export default withOnline(
  withNotify(
    withLoader(
      ChooseSurgeon
    )
  )
);
